import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { IdentityProviderCreatePage } from '@/features/access/identity-providers/identity-provider-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/identity-providers/new')({
  component: NewIdentityProviderRoute,
});

function NewIdentityProviderRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="members"
      crumbs={[
        { label: t('access.identityProviders.title') },
        { label: t('access.identityProviders.newTitle') },
      ]}
    >
      <IdentityProviderCreatePage tenantId={tenant} />
    </ConsoleShell>
  );
}
